module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-BoldItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-BoldItalic-webfont.ttf
// module id = 1620
// module chunks = 0